import React, { ReactElement, ReactNode } from 'react';
import RingilButton from '@components/ringil3/Buttons/RingilButton.tsx';
import RingilDialog from '@components/RingilComponents/RingilDialog.tsx';
import COInlineMessage from '@components/ringil3/COInlineMessage/COInlineMessage.tsx';
import { VerticalFieldAndValueWithIcon } from '@components/ringil3/Containers/VerticalFieldAndValueWithIcon.tsx';
import { isNotNullOrUndefined } from '@utils/utils.tsx';

/** Optional "for expedition FV—00001" block above the question, same shape as in the sidebars. */
export interface ConfirmDialogEntity {
  label: string;
  value: string;
  icon?: ReactElement;
  iconPath?: string;
}

interface ComponentProps {
  visible: boolean;
  dialogTitle: string;
  dialogMessage: ReactNode;
  onCancel?: () => void;
  onConfirm?: () => void;
  onAcceptButtonText: string;
  onCancelButtonText: string;
  loading?: boolean;
  entity?: ConfirmDialogEntity;
  dataTestId?: string;
}

const ConfirmDialog: React.FC<ComponentProps> = ({
  visible,
  dialogMessage,
  onConfirm = () => {},
  onCancel = () => {},
  dialogTitle,
  onAcceptButtonText,
  onCancelButtonText,
  loading = false,
  entity,
  dataTestId,
}) => {
  return (
    <RingilDialog
      visible={visible}
      heading={dialogTitle}
      onHide={() => onCancel()}
      dataTestId={dataTestId}
      footer={
        <>
          <RingilButton mode="filled-rectangle" size="big" label={onAcceptButtonText} onClick={() => onConfirm()} loading={loading} />
          <RingilButton mode="link" size="big" label={onCancelButtonText} onClick={() => onCancel()} disabled={loading} />
        </>
      }
    >
      {isNotNullOrUndefined(entity) && (
        <div className={'flex flex-col gap-4'}>
          <VerticalFieldAndValueWithIcon label={entity.label} valueText={entity.value} icon={entity.icon} iconPath={entity.iconPath} />
          <hr className={'m-0 w-full border-0 border-t border-solid border-content-quaternary'} />
        </div>
      )}
      <COInlineMessage variant={'info'} buttons={null}>{dialogMessage}</COInlineMessage>
    </RingilDialog>
  );
};

export default ConfirmDialog;
